import { Homeowner } from "@app/models/Homeowner";
import { Property } from "@app/models/Property";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { PaymentRequestDetail } from "@app/models/PaymentRequestDetail";
import { PropertyApi } from "@app/services/apiServices/PropertyApi";
import { moneyNumber } from "@app/util/money-number";
import { AmenityApi } from "@app/services/apiServices/AmenityApi";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";
import { Amenity } from "@app/models/Amenity";
import { AmenityService } from "@app/services/Amenity.service";
import { AmenityNameCatalog } from "@app/models/AmenityNameCatalog";
import { take } from "rxjs/operators";
import { SpinnerService } from "@app/services/spinner.service";
import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-guest-amenities-payment-select-amenities',
    template: require('./guestAmenitiesPaymentSelectAmenities.html')
})
export class GuestAmenitiesPaymentSelectAmenitiesComponent implements OnInit{

    homeowner: Homeowner;
    property: Property;
    cartItems: PaymentRequestDetail[] = [];
    itemsTotal: number;
    allowPayByCheck: boolean = true;
    allowPayByCard: boolean = true;
    availableAmenities: Amenity[];
    availableCategories: AmenityNameCatalog[];
    cartItemsValidated: boolean = false;
    propertyValidated: boolean = false;

    constructor(
        @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
        @Inject(PropertyApi) private propertyApi: PropertyApi,
        @Inject(AmenityApi) private amenityApi: AmenityApi,
        @Inject(AmenityService) private amenityService: AmenityService,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
        @Inject(Router) private router: Router) {}

    ngOnInit() {
        this.spinnerService.closeSpinner();
        this.setDefaultValues();
    }

    setDefaultValues() {
        this.itemsTotal = 0.00;
        // get current homeowner or default to empty values
        this.homeowner = this.guestPaymentStore.getHomeowner();
        this.property = this.guestPaymentStore.getProperty() || { address: {} };
        if (this.guestPaymentStore.getPaymentRequest() != null) {
            this.cartItems = this.guestPaymentStore.getPaymentRequest().details;
            if (this.cartItems) {
                this.updateTotal();
                this.validateCartItems();
            }
        }

        if (this.homeowner == null || this.property == null) {
            !window.__karma__ && console.error('Either homeowner or property was undefined. Redirecting to guest contact form.', {
                homeowner: this.homeowner,
                property: this.property
            })
            // redirect to page for filling out info
            this.router.navigateByUrl('/amenities/guestpayment');
            return
        }

        this.setAmenities(this.property.hoa.pmc.couponId, this.property.hoa.couponId, this.property.couponId).then(() => {
            this.cartItemsValidated = true;
        });
        this.validateProperty();
    }

    validateCartItems() {
        this.setAmenities(this.property.hoa.pmc.couponId, this.property.hoa.couponId, this.property.couponId).then(() => {
            this.amenityService.validateCartItems(this.availableAmenities, this.cartItems);
        }, () => {});
    }

    setAmenities(pmcCouponId: string, hoaCouponId: string, propertyCouponId: string) {
        return new Promise<void>((resolve, reject) => {
            this.amenityApi.activeAmenitiesByCouponGet(true, pmcCouponId, hoaCouponId, propertyCouponId)
                .pipe(take(1)).subscribe((response) => {
                    this.availableAmenities = response;
                    this.availableCategories = this.amenityService.getAvailableCategories(this.availableAmenities);
                    resolve();
                }, (err) => {
                    let errMsg: string = undefined;
                    if (err.error && err.error.message) {
                        errMsg = err.error.message;
                    }
                    this.errorHandlerService.handleNetworkError(err, true, errMsg)
                        .pipe(take(1)).subscribe(() => {}, () => {});
                    reject();
                });
        })
    }

    updateTotal() {
        let tempTotal = 0;
        this.cartItems.forEach(cartItem => {
            tempTotal += cartItem.qty * cartItem.amount;
        })
        this.itemsTotal = moneyNumber(tempTotal);
    }

    validateProperty() {
        this.propertyApi.propertiesValidateGet(
            true,
            this.property.hoa.pmc.couponId,
            this.property.hoa.couponId,
            this.property.couponId
        ).pipe(take(1)).subscribe((validateResp) => {
            this.setAllowCheckAndCard(validateResp.achPayments, validateResp.cardPayments);
            this.propertyValidated = true;
        });
    }

    setAllowCheckAndCard(allowPayByCheck: boolean, allowPayByCard: boolean) {
        this.allowPayByCheck = allowPayByCheck;
        this.allowPayByCard = allowPayByCard;
    }

    doneLoading() {

    }
}
